module.exports = __webpack_public_path__ + "static/media/imgCanvasBusiness.29f7bbb3.svg";